module.exports = __webpack_public_path__ + "media/images/1200/sleep_apnea_get_good_sleep-8eef1aaab0494d9607fcbb698f9d12e9.jpg";